import PropTypes from "prop-types";

export default PropTypes.oneOf(["all", "any", "none"]);
